import React, { useState } from 'react';
import './dubai.css';

const Dubai = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseOver = () => {
    setIsVisible(true);
  };

  const handleMouseOut = () => {
    setIsVisible(false);
  };

  return (
    <>
      <div
        className="uae"
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
      ></div>
      <div className="contact-item-dubai">
        <div className={`content ${isVisible ? 'd-flex' : 'd-none'}`}>
          <div className="item">
            <p>Dubai, UAE</p>
          </div>
          <img
            src={`${process.env.PUBLIC_URL}/images/bottom.svg`}
            alt="arrow bottom"
            className="arrow-down"
          />
        </div>
      </div>
    </>
  );
};

export default Dubai;
